import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

// import { useParams } from 'react-router-dom'


import { Modal, Button } from 'react-bootstrap'

import { Form, Col, Row } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';

import Dialog from '../../services/Dialogs'

const AgregarUsuarioModal = ( props ) => {
  // const [show] = useState(false);

	// const REG_CURP = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
	const REG_NOMBRES = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u




    const dialog = new Dialog();

	const schema = yup.object().shape({
          email: yup.string().email().required('El email es un campo obligatorio'),
          username: yup.string().matches(/^[a-zA-Z0-9_.]+$/,'El formato del nombre de usuario es incorrecto. Intenta sin carácteres especiales ni espacios.').required('Este campo es obligatorio'),
          celular: yup.string().matches(/^\d{10}$/,'Formato Invalido, solo puedes introducir 10 números').required('Obligatorio'),
          nombres: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El nombre es obligatorio'),
          paterno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido").required('El primer apellido es obligatorio'),
          materno: yup.string().matches( REG_NOMBRES , "Formato de nombre no valido"),
          sexo: yup.string(),
          // curp: yup.string().matches( REG_CURP , "Formato de CURP invalido").required('El CURP es un campo obligatorio'),

          iddepartamento: yup.number().required('Debes seleccionar un departamento'),
          // fecha_tramite: yup.date().required(),
        })
	

  const { show, handleClose, nuevo_usuario_form, tipo_usuario, uuid_sucursal } = props

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);

  	const [ departamentos, setDepartamentos ] = useState<any>([])


	const cargar = async () =>{
	  try{
	    let response = await RequestService.getEndPoint('deptos/'+uuid_sucursal)
	    setDepartamentos(response.data)
	  }
	  catch(e){
	    toast.error('Error al cargar')
	  }
	}

	React.useEffect(() => {
		if(tipo_usuario===2){
			cargar()
		}
		else{
			setDepartamentos([])
		}
	}, [tipo_usuario]);




  return (
    <>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Crear Cuenta de Acceso</Modal.Title>
        </Modal.Header>
        <Modal.Body>

{
	tipo_usuario === 1 && (
			<div className="alert alert-primary">
			  <p className="text-center nm"><b>TIPO DE USUARIO </b><br/> GERENTE</p>
			</div>
	)
}

{
	tipo_usuario === 2 && (
			<div className="alert alert-dark">
			  <p className="text-center nm"><b>TIPO DE USUARIO </b><br/> SUPERVISOR DE MESA DE VERIFICACIÓN</p>
			</div>
	)
}

{
	tipo_usuario === 3 && (
			<div className="alert alert-secondary">
			  <p className="text-center nm"><b>TIPO DE USUARIO </b><br/> ASESOR</p>
			</div>
	)
}




				    <Formik
						enableReinitialize={true}
						validationSchema={schema}
						onSubmit={ async (values : any, { setSubmitting }) => {

					        try{

					        	if( await dialog.confirm( '¿Estás seguro?', {} ) ){

							          // console.log('GUARDAR CAMBIOS???')
							          var SENDING = {...values}
							          SENDING.tipo_usuario = tipo_usuario
							          // SENDING.uuid_sucursal = uuid_sucursal
							          console.table(SENDING);
							          
							          await RequestService.create('agregar_usuario/'+uuid_sucursal, SENDING )
							          toast.success('El Usuario fue creado')
							          handleClose()
					      		}


					        }
					        catch(e){
					          console.log(e)
					           toast.error('Problemas al intentar guardar los cambios');  
					         }

				      }}
				      initialValues={ nuevo_usuario_form }
				    >
				      {({
				        handleSubmit,
				        handleChange,
				        setFieldValue,

				        values,
				        touched,
				        isValid,
				        errors,
				      }) => (

				        <Form noValidate onSubmit={handleSubmit}>



				              <div className="row">

				                  <div className="col">

				                  
				                      <>

				                              <h4>Información del Usuario</h4>


												{
													tipo_usuario === 2 && (

												            <Row className="mb-3">

												                <Form.Group as={Col} md="12">
												                  <Form.Label>Departamento</Form.Label>
																		<Form.Select 
																			name="iddepartamento"
																			value={values.iddepartamento}
																			onChange={handleChange}
																			isValid={touched.iddepartamento && !errors.iddepartamento}
																			isInvalid={!!errors.iddepartamento}>
																		  <option value="" disabled>Selecciona un departamento de la lista</option>
																		  {departamentos.map( (reg:any) =>
																		      <option disabled={reg.id===0} key={ Math.random().toString(36).substr(2, 9) }  value={reg.id}>{reg.departamento}</option>
																		  )}
																		</Form.Select>
												                    <Form.Control.Feedback type="invalid">
												                      {errors.iddepartamento}
												                    </Form.Control.Feedback>
												                </Form.Group>

												            </Row>

													)
												}





				                            <Row className="mb-3">


				                                <Form.Group as={Col} md="8">
				                                  <Form.Label>Nombre de Usuario</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="text"
				                                    name="username"
				                                    value={values.username}
				                                    onChange={(e)=>{ setFieldValue('username', (e.target.value || "")) }}
				                                    isValid={touched.username && !errors.username}
				                                    isInvalid={!!errors.username}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.username}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                            </Row>



				                            <Row className="mb-3">


				                                <Form.Group as={Col} md="8">
				                                  <Form.Label>Correo Electrónico</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="email"
				                                    name="email"
				                                    value={values.email}
				                                    onChange={(e)=>{ setFieldValue('email', e.target.value ) }}
				                                    isValid={touched.email && !errors.email}
				                                    isInvalid={!!errors.email}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.email}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                            </Row>


				                            <Row className="mb-3">


				                                <Form.Group as={Col} md="6">
				                                  <Form.Label>Número de Celular</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="number"
				                                    name="celular"
				                                    value={values.celular}
				                                    onChange={(e)=>{ setFieldValue('celular', e.target.value ) }}
				                                    isValid={touched.celular && !errors.celular}
				                                    isInvalid={!!errors.celular}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.celular}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                            </Row>



				                            <Row className="mb-3">


				                                <Form.Group as={Col} md="7">
				                                  <Form.Label>Nombre(s)</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="text"
				                                    name="nombres"
				                                    value={values.nombres}
				                                    onChange={(e)=>{ setFieldValue('nombres', (e.target.value.toUpperCase() || "")) }}
				                                    isValid={touched.nombres && !errors.nombres}
				                                    isInvalid={!!errors.nombres}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.nombres}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                            </Row>



				                            <Row className="mb-3">


				                                <Form.Group as={Col} md="6">
				                                  <Form.Label>Apellido Paterno</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="text"
				                                    name="paterno"
				                                    value={values.paterno}
				                                    onChange={(e)=>{ setFieldValue('paterno', (e.target.value.toUpperCase() || "")) }}
				                                    isValid={touched.paterno && !errors.paterno}
				                                    isInvalid={!!errors.paterno}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.paterno}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                                <Form.Group as={Col} md="6">
				                                  <Form.Label>Apellido Materno</Form.Label>
				                                  <Form.Control
				                                    required
				                                    type="text"
				                                    name="materno"
				                                    value={values.materno}
				                                    onChange={(e)=>{ setFieldValue('materno', (e.target.value.toUpperCase() || "")) }}
				                                    isValid={touched.materno && !errors.materno}
				                                    isInvalid={!!errors.materno}
				                                  />
				                                    <Form.Control.Feedback type="invalid">
				                                      {errors.materno}
				                                    </Form.Control.Feedback>
				                                </Form.Group>


				                            </Row>

				                            <Row className="mb-3">


										        <div >
										            <label className="form-label d-block">Sexo</label>
										            <div className="form-check form-check-inline">
										                <input className="form-check-input" id="hombre" type="radio" name="sexo" value="H" onChange={()=>{ setFieldValue('sexo', "H" ) }} />
										                <label className="form-check-label" htmlFor="hombre">Hombre</label>
										            </div>
										            <div className="form-check form-check-inline">
										                <input className="form-check-input" id="mujer" type="radio" name="sexo" value="M" onChange={()=>{ setFieldValue('sexo', "M" ) }} />
										                <label className="form-check-label" htmlFor="mujer">Mujer</label>
										            </div>
										        </div>

				                            	
				                            </Row>

				                              
				                              <Button type="submit">CREAR USUARIO</Button>





				                      </>
				                    
				                  




				                  </div>
				                    
				              </div>


				        </Form>

				      )}

				    </Formik>



        </Modal.Body>

      </Modal>
    </>
  );
}


export default AgregarUsuarioModal